<!-- <img class="loader" src="/assets/images/logo-small.png" alt="Sun Logo"/> -->
<ng-container *ngIf="load">
<div class="loading">

	<!-- <div class="loader">
		<div class="sp sp-hydrogen"></div>
		Please Wait...
	</div> -->
</div>
</ng-container>